import { SVG_ENUM } from "enums";
import SVG from "shared/SVG";
import "./Warning.scss";

interface WarningProps {
  svg?: SVG_ENUM;
  text: string | JSX.Element;
  className?: string;
  styleType?: "red" | "gray" | "white" | "gray-with-border";
}

const formatNumbers = (value: string | JSX.Element): string | JSX.Element => {
  if (typeof value !== "string") return value;
  return value.replace(/\d+/g, (match) =>
    match.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0"),
  );
};

const Warning: React.FC<WarningProps> = ({
  svg,
  text,
  className = "",
  styleType = "red",
}: WarningProps) => {
  return (
    <div className={`warning ${className} warning--${styleType}`}>
      <div className="warning__svg">
        <SVG type={svg || SVG_ENUM.ANNOTATION_ALERT} />
      </div>
      <div className="warning__text">{formatNumbers(text)}</div>
    </div>
  );
};

export default Warning;
